import { GetCustomerDomainEngagementResponseData } from "@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";

import { EngagementMetrics } from "./types";

export const calculateEngagementMetrics = (
    engagementData: GetCustomerDomainEngagementResponseData
): EngagementMetrics => {
    const embedCount = engagementData.engagementProjects.reduce(
        (total, project) => {
            return (
                total +
                project.boards.reduce((boardTotal, board) => {
                    return boardTotal + board.embeds.length;
                }, 0)
            );
        },
        0
    );

    const boardCount = engagementData.engagementProjects.reduce(
        (total, project) => {
            return total + project.boards.length;
        },
        0
    );

    const projectCount = engagementData.engagementProjects.length;
    const spaceCount = engagementData.engagementSpaces.length;

    return {
        embedCount,
        boardCount,
        projectCount,
        spaceCount
    };
};
